import React from 'react';
import {
  LayoutDashboard,
  CreditCard,
  Boxes,
  Building,
  MessageSquareHeart,
  ShieldCheck,
  UserCheck,
  Contact2,
  Map,
  Hammer,
  Vote,
  FileCheck2,
  Sparkles,
  FileDown,
  Settings,
  LineChart,
  ChevronLeft,
  ChevronRight,
  Building2,
  Bell,
  Menu,
  X,
} from 'lucide-react';

export type AdminTabKey =
  | 'overview'
  | 'finance'
  | 'inventory'
  | 'assets'
  | 'feedback'
  | 'security'
  | 'members_affairs'
  | 'residents_registry'
  | 'project_info'
  | 'developer'
  | 'agm_voting'
  | 'gov_filing'
  | 'services'
  | 'downloads'
  | 'settings'
  | 'analytics';

export interface AdminMenuItem {
  key: AdminTabKey;
  number: number;
  label: string;
  shortLabel: string;
  icon: React.ElementType;
  badgeKey?: string;
  color: string;
  activeBg: string;
}

export const ADMIN_MENU_ITEMS: AdminMenuItem[] = [
  {
    key: 'overview',
    number: 1,
    label: '1. ภาพรวม (Dashboard)',
    shortLabel: 'ภาพรวม',
    icon: LayoutDashboard,
    color: 'text-blue-400',
    activeBg: 'bg-blue-600/20 text-blue-300 border-blue-500/40',
  },
  {
    key: 'finance',
    number: 2,
    label: '2. บัญชีและการเงิน',
    shortLabel: 'บัญชีและการเงิน',
    icon: CreditCard,
    badgeKey: 'pendingBills',
    color: 'text-amber-400',
    activeBg: 'bg-amber-600/20 text-amber-300 border-amber-500/40',
  },
  {
    key: 'inventory',
    number: 3,
    label: '3. งานสต็อกและวัสดุสิ้นเปลือง',
    shortLabel: 'สต็อก & พัสดุ',
    icon: Boxes,
    badgeKey: 'lowStock',
    color: 'text-cyan-400',
    activeBg: 'bg-cyan-600/20 text-cyan-300 border-cyan-500/40',
  },
  {
    key: 'assets',
    number: 4,
    label: '4. งานบริหารทรัพย์ส่วนกลาง',
    shortLabel: 'ทรัพย์ส่วนกลาง',
    icon: Building,
    color: 'text-emerald-400',
    activeBg: 'bg-emerald-600/20 text-emerald-300 border-emerald-500/40',
  },
  {
    key: 'feedback',
    number: 5,
    label: '5. แนะนำติชมจาก user',
    shortLabel: 'แนะนำติชม',
    icon: MessageSquareHeart,
    badgeKey: 'pendingFeedback',
    color: 'text-rose-400',
    activeBg: 'bg-rose-600/20 text-rose-300 border-rose-500/40',
  },
  {
    key: 'security',
    number: 6,
    label: '6. งาน รปภ.',
    shortLabel: 'งาน รปภ.',
    icon: ShieldCheck,
    color: 'text-emerald-400',
    activeBg: 'bg-emerald-600/20 text-emerald-300 border-emerald-500/40',
  },
  {
    key: 'members_affairs',
    number: 7,
    label: '7. งานเจ้าของร่วม/สมาชิก',
    shortLabel: 'งานสมาชิก/คำร้อง',
    icon: UserCheck,
    badgeKey: 'pendingPetitions',
    color: 'text-purple-400',
    activeBg: 'bg-purple-600/20 text-purple-300 border-purple-500/40',
  },
  {
    key: 'residents_registry',
    number: 8,
    label: '8. ทะเบียนเจ้าของร่วม/สมาชิก',
    shortLabel: 'ทะเบียนสมาชิก',
    icon: Contact2,
    color: 'text-blue-400',
    activeBg: 'bg-blue-600/20 text-blue-300 border-blue-500/40',
  },
  {
    key: 'project_info',
    number: 9,
    label: '9. ข้อมูลโครงการ',
    shortLabel: 'ข้อมูลโครงการ',
    icon: Map,
    color: 'text-indigo-400',
    activeBg: 'bg-indigo-600/20 text-indigo-300 border-indigo-500/40',
  },
  {
    key: 'developer',
    number: 10,
    label: '10. สำหรับผู้พัฒนาโครงการ',
    shortLabel: 'ผู้พัฒนาโครงการ',
    icon: Hammer,
    badgeKey: 'activeDefects',
    color: 'text-orange-400',
    activeBg: 'bg-orange-600/20 text-orange-300 border-orange-500/40',
  },
  {
    key: 'agm_voting',
    number: 11,
    label: '11. งานประชุมใหญ่/ลงคะแนนเสียง',
    shortLabel: 'ประชุมใหญ่ & โหวต',
    icon: Vote,
    badgeKey: 'activeVotes',
    color: 'text-teal-400',
    activeBg: 'bg-teal-600/20 text-teal-300 border-teal-500/40',
  },
  {
    key: 'gov_filing',
    number: 12,
    label: '12. งานยื่นเอกสารให้หน่วยงาน',
    shortLabel: 'ยื่นเอกสารราชการ',
    icon: FileCheck2,
    color: 'text-sky-400',
    activeBg: 'bg-sky-600/20 text-sky-300 border-sky-500/40',
  },
  {
    key: 'services',
    number: 13,
    label: '13. บริการเสริม',
    shortLabel: 'บริการเสริม',
    icon: Sparkles,
    color: 'text-pink-400',
    activeBg: 'bg-pink-600/20 text-pink-300 border-pink-500/40',
  },
  {
    key: 'downloads',
    number: 14,
    label: '14. เอกสารที่ดาวน์โหลด',
    shortLabel: 'เอกสารดาวน์โหลด',
    icon: FileDown,
    color: 'text-emerald-400',
    activeBg: 'bg-emerald-600/20 text-emerald-300 border-emerald-500/40',
  },
  {
    key: 'settings',
    number: 15,
    label: '15. ตั้งค่า',
    shortLabel: 'ตั้งค่าระบบ',
    icon: Settings,
    color: 'text-slate-300',
    activeBg: 'bg-slate-700/60 text-slate-200 border-slate-500/40',
  },
  {
    key: 'analytics',
    number: 16,
    label: '16. วิเคราะห์ข้อมูล',
    shortLabel: 'วิเคราะห์ข้อมูล (BI)',
    icon: LineChart,
    color: 'text-violet-400',
    activeBg: 'bg-violet-600/20 text-violet-300 border-violet-500/40',
  },
];

interface Props {
  activeTab: AdminTabKey;
  setActiveTab: (tab: AdminTabKey) => void;
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  badgeCounts: { [key: string]: number };
  isMobileOpen: boolean;
  setIsMobileOpen: (open: boolean) => void;
}

export const AdminSidebar: React.FC<Props> = ({
  activeTab,
  setActiveTab,
  isCollapsed,
  setIsCollapsed,
  badgeCounts,
  isMobileOpen,
  setIsMobileOpen,
}) => {
  return (
    <>
      {/* Mobile Backdrop Overlay */}
      {isMobileOpen && (
        <div
          onClick={() => setIsMobileOpen(false)}
          className="fixed inset-0 z-40 bg-slate-950/70 backdrop-blur-xs lg:hidden"
        />
      )}

      {/* Sidebar Container */}
      <aside
        className={`fixed lg:sticky top-0 left-0 z-40 h-screen bg-slate-900 text-slate-200 border-r border-slate-800/80 flex flex-col transition-all duration-300 ease-in-out shrink-0 select-none shadow-xl print:hidden ${
          isCollapsed ? 'w-[76px]' : 'w-[280px]'
        } ${
          isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        {/* Top Header & Project Identity */}
        <div className="h-16 px-3.5 flex items-center justify-between border-b border-slate-800 shrink-0 bg-slate-950/60">
          {!isCollapsed ? (
            <div className="flex items-center gap-2.5 overflow-hidden">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-blue-700 to-indigo-600 flex items-center justify-center text-white shadow-md shadow-blue-700/30 shrink-0">
                <Building2 className="w-5 h-5" />
              </div>
              <div className="truncate">
                <h1 className="text-xs font-bold text-white tracking-wide truncate">
                  นราวดี อิลิแกนซ์
                </h1>
                <p className="text-[10px] text-blue-400 font-medium truncate">
                  Admin Juristic Suite
                </p>
              </div>
            </div>
          ) : (
            <div className="mx-auto">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-blue-700 to-indigo-600 flex items-center justify-center text-white shadow-md shadow-blue-700/30">
                <Building2 className="w-5 h-5" />
              </div>
            </div>
          )}

          {/* Collapse/Expand Toggle Button (Desktop) */}
          <div className="hidden lg:flex items-center">
            <button
              onClick={() => setIsCollapsed((prev) => !prev)}
              title={isCollapsed ? 'ขยายเมนูชื่อเต็ม (Expand Menu)' : 'ย่อเหลือแต่ไอคอน (Collapse Menu)'}
              className="p-1.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-colors cursor-pointer border border-slate-700"
            >
              {isCollapsed ? (
                <ChevronRight className="w-4 h-4" />
              ) : (
                <ChevronLeft className="w-4 h-4" />
              )}
            </button>
          </div>

          {/* Close Button on Mobile */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileOpen(false)}
              className="p-1.5 rounded-lg text-slate-400 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Quick Menu Status / Toggle Helper */}
        <div className="px-3 py-2 border-b border-slate-800/60 bg-slate-900/50 flex items-center justify-between text-[11px] text-slate-400">
          {!isCollapsed ? (
            <>
              <span className="font-semibold text-slate-300">เมนูหลักนิติบุคคล (16 เมนู)</span>
              <button
                onClick={() => setIsCollapsed(true)}
                className="text-[10px] text-blue-400 hover:text-blue-300 font-medium underline"
              >
                ย่อไอคอน
              </button>
            </>
          ) : (
            <button
              onClick={() => setIsCollapsed(false)}
              title="ขยายแสดงชื่อเต็ม"
              className="w-full text-center text-[10px] text-blue-400 hover:text-blue-300 font-medium"
            >
              ขยาย
            </button>
          )}
        </div>

        {/* Scrollable Navigation List */}
        <nav className="flex-1 overflow-y-auto px-2 py-3 space-y-1 scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-transparent">
          {ADMIN_MENU_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.key;
            const badgeCount = item.badgeKey ? badgeCounts[item.badgeKey] || 0 : 0;

            return (
              <button
                key={item.key}
                onClick={() => {
                  setActiveTab(item.key);
                  setIsMobileOpen(false);
                }}
                title={isCollapsed ? item.label : undefined}
                className={`w-full group relative flex items-center gap-3 px-3 py-2.5 rounded-xl text-xs font-medium transition-all duration-150 cursor-pointer border ${
                  isActive
                    ? `${item.activeBg} font-bold shadow-xs`
                    : 'border-transparent text-slate-400 hover:text-slate-100 hover:bg-slate-800/70'
                } ${isCollapsed ? 'justify-center px-0' : 'justify-start'}`}
              >
                {/* Icon with Color */}
                <div
                  className={`p-1.5 rounded-lg shrink-0 transition-transform duration-200 group-hover:scale-110 ${
                    isActive
                      ? 'bg-white/10 text-white'
                      : `${item.color} bg-slate-800/80 group-hover:bg-slate-800`
                  }`}
                >
                  <Icon className="w-4 h-4" />
                </div>

                {/* Text Label (Hidden when collapsed) */}
                {!isCollapsed && (
                  <span className="truncate text-left flex-1 tracking-tight">
                    {item.label}
                  </span>
                )}

                {/* Badge Count if available */}
                {badgeCount > 0 && (
                  <>
                    {!isCollapsed ? (
                      <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-500 text-white shadow-xs shrink-0">
                        {badgeCount}
                      </span>
                    ) : (
                      <span className="absolute top-1.5 right-2 w-2 h-2 rounded-full bg-amber-500 ring-2 ring-slate-900" />
                    )}
                  </>
                )}

                {/* Tooltip on Hover in Collapsed Mode */}
                {isCollapsed && (
                  <div className="absolute left-full ml-2.5 px-3 py-1.5 bg-slate-950 text-white text-xs font-semibold rounded-lg shadow-xl border border-slate-700 whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity z-50">
                    {item.label}
                    {badgeCount > 0 && ` (${badgeCount})`}
                  </div>
                )}
              </button>
            );
          })}
        </nav>

        {/* Bottom User / Toggle Bar */}
        <div className="p-3 border-t border-slate-800/80 bg-slate-950/40 shrink-0">
          {!isCollapsed ? (
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 truncate">
                <div className="w-7 h-7 rounded-full bg-blue-600/30 text-blue-400 border border-blue-500/30 flex items-center justify-center font-bold text-xs shrink-0">
                  AD
                </div>
                <div className="truncate text-left">
                  <p className="text-xs font-semibold text-slate-200 truncate">
                    คุณศศิธร สุขสมบูรณ์
                  </p>
                  <p className="text-[10px] text-slate-400 truncate">
                    ผู้จัดการนิติบุคคล
                  </p>
                </div>
              </div>

              <button
                onClick={() => setIsCollapsed(true)}
                title="ย่อเมนูเหลือแต่ Icon"
                className="p-1.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-colors cursor-pointer"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
            </div>
          ) : (
            <button
              onClick={() => setIsCollapsed(false)}
              title="ขยายแสดงชื่อเต็ม"
              className="w-full flex justify-center p-1.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-colors cursor-pointer"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          )}
        </div>
      </aside>
    </>
  );
};
